module.exports = __webpack_public_path__ + "static/media/change-direction.7c19d34b.svg";